import { FC } from 'react';

import { Box, Typography, useTheme } from '@mui/material';
import { useTranslation } from 'next-i18next';

import FontAwesomeIcon from '@components/atoms/fontAwesomeIcon';
import ProductCustomGlanceSkeleton from '@components/store/product/productCustomGlance/productCustomGlanceSkeleton';
import { useCourseGlance } from '@hooks/course/useCourseGlance';

type ProductCustomGlanceProps = {
  idName: string;
};

const ProductCustomGlance: FC<ProductCustomGlanceProps> = ({ idName }) => {
  const { t } = useTranslation('store_course');
  const theme = useTheme();

  const { courseDetailGlancesData, courseDetailGlancesDataLoading } = useCourseGlance({ idName });

  if (courseDetailGlancesDataLoading) {
    return <ProductCustomGlanceSkeleton />;
  }

  if (!courseDetailGlancesDataLoading && !courseDetailGlancesData?.glances?.length) {
    return null;
  }

  return (
    <Box border="1px solid #0000001F" borderRadius={1} padding={3}>
      <Typography variant="h5">{t('course_detail.course_description.course_glance.title')}</Typography>

      <Box mt={2}>
        {courseDetailGlancesData.glances.map(({ name }) => {
          return (
            <Box key={name} display="flex" gap={1}>
              <FontAwesomeIcon
                icon="fa-sharp fa-regular fa-check"
                color={theme.palette.primary.main}
                style={{ fontSize: 14, marginTop: 2 }}
              />
              <Typography variant="body1lanna">{name}</Typography>
            </Box>
          );
        })}
      </Box>
    </Box>
  );
};

export default ProductCustomGlance;
